<template>
  <el-drawer v-model="model" :size="anchoSidebar" direction="ltr"
    header-class="bg-primary d-flex  align-items-center py-1 text-white my-0" footer-class="p-50"
    body-class="p-0 d-flex align-items-center" @show="scrollear">

    <template #header>
      <div class="d-flex align-items-center">

        <font-awesome-icon icon="fas fa-comments" class="me-1" />
        <strong class="me-1 fs-4">Chat de Soporte</strong>
        <BAvatarGroup size="sm">
          <BAvatar  v-for="user in usuarios" :key="user.id" :src="user.avatar" v-b-tooltip.hover="user.fullname" />
        </BAvatarGroup>

      </div>
    </template>

    <ChatPanel :actions="actionsChat" class="h-100 " is-component />


    <template #footer>
      <b-form @submit.prevent="enviarMensaje" v-show="aperturado">
        <b-input-group>
          <b-form-input type="search" class="input-form" autofocus v-model="mensaje" placeholder="Establece tu mensaje."
            :readonly="loading || esperandoRespuesta" :disabled="esperandoRespuesta" v-bind="mensaje_attrs"
            :state="!errors.mensaje" />
          <b-button type="submit" variant="primary" :disabled="loading">
            <font-awesome-icon icon="fas fa-paper-plane" />
          </b-button>
        </b-input-group>
      </b-form>
    </template>
  </el-drawer>
</template>

<script setup>
  import ChatPanel from 'components/ChatPanel.vue';
  import useChatComponent from '@composables/useChatComponent';

import { storeToRefs } from 'pinia';
import useUsuarioStore from '@/store/usuario';
import { required } from '@validations';
import useUtils from '@composables/useUtils.js';


  import {
    useForm
  } from 'vee-validate';

  const model = defineModel({
    type: Boolean,
    default:false,
  })

 
  const props = defineProps({
    modelo: {
      type: String,
      default: null
    },
    modeloId: {
      type: [String,Number],
      default: null
    }
  });

  const {modelo,modeloId} = toRefs(props);

  const usuario_store = useUsuarioStore();

  const { isAdmin } = storeToRefs(usuario_store);
  const { loading,anchoSidebar } = useUtils();

  const actionsChat = useChatComponent(model,modelo,modeloId);

  const {
    // state and getters
    modelShow,
    mensajes,
    formulario,
    usuario,
    usuarios,
    aperturado,
    refChatLogPS,
    esperandoRespuesta,
    // methods
    scrollToBottomInChatLog,
    cerrar,
    aperturarChat,
    leaveChannel,
    enviar,
  }  = actionsChat;

const { defineField, errors, handleSubmit, resetForm,setErrors } = useForm({
  initialValues: formulario,
  validationSchema: {
    mensaje: required
  }
});

const [mensaje, mensaje_attrs] = defineField('mensaje');


const enviarMensaje = handleSubmit((values) => {
  enviar(values, scrollToBottomInChatLog,setErrors)
  resetForm();
});


// watch([modeloId,modelo],() => {
//   resetForm({
//     values:formulario.value
//   });
// });

const scrollear = () => {
  setTimeout(() => {
    scrollToBottomInChatLog();
  }, 500);
}


</script>
